module.exports = __webpack_public_path__ + "ca14b882230f59e475ad380a273c54d1.svg";